// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__9vU6L"};